<div id="alert-container">
  <app-alert-actionbar></app-alert-actionbar>
  <div id="alert-grid" [ngClass]="{ 'disabled-grid': alertsDisabled() }">
    <ag-grid-angular
      class="ag-theme-cdx set-filter-custom"
      [rowData]="tableRowData | async"
      [gridOptions]="gridOptions"
      [animateRows]="true"
      (gridReady)="onGridReady($event)"
    >
    </ag-grid-angular>
  </div>
  @if (alertsDisabled()) {
  <div
    class="disabled-overlay"
    #disabledOverlay
    (wheel)="onOverlayWheel($event)"
  ></div>
  }
</div>
